export const filterConfig = [
/*   {
    id: 'NumeroContainer',
    type: 'text',
    label: 'Numero do container',
    placeholder: 'Digite o numero do container'
  }, */
  {
    id: 'TagAnexo',
    type: 'select',
    label: 'Tag Anexo',
    placeholder: 'Selecione...',
    options: [
      { value: 'Coleta', label: 'Coleta' },
      { value: 'Devolucao', label: 'Devolucao' },
      { value: 'RIC', label: 'RIC' },
      { value: 'CTE', label: 'CTE' }
    ]
  },
  {
    id: 'DataColetaDepot',
    type: 'datePicker',
    pickerType: 'datetime',
    label: 'Data Coleta',
    placeholder: 'Digite a data coleta'
  },
];

